module.exports = __webpack_public_path__ + "static/media/m_beard_medium_long__square.9e610bf8.png";